import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import ManufacturersPage from '../pages/manufacturers/page';
import ManufacturerDetailPage from '../pages/manufacturer-detail/page';
import BuyerToolsPage from '../pages/buyer-tools/page';

const HomePage = lazy(() => import('../pages/platform/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ManufacturersPage = lazy(() => import('../pages/manufacturers/page'));
const ManufacturerDetailPage = lazy(() => import('../pages/manufacturer-detail/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/manufacturers',
    element: <ManufacturersPage />,
  },
  {
    path: '/manufacturer/:id',
    element: <ManufacturerDetailPage />,
  },
  {
    path: '/buyer-tools',
    element: <BuyerToolsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;